export default "__VITE_ASSET__BkYHhVLY__"